import React from "react";

const About = () => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
            <div className="text-center p-4 md:p-8">
                <h1 className="text-6xl md:text-8xl font-bold text-gray-800 mb-4">About</h1>
                <p className="text-lg md:text-2xl text-gray-600 mb-6">Welcome to About Page</p>
            </div>
        </div>
    );
}

export default About;